const SPACES_REGEX = /\s+/g;
const addPartForAdditionalItems = (additionalItems, parts) => {
    if (additionalItems == null) {
        return;
    }
    // For let index = ... is the fastest for loop
    for (let index = 0; index < additionalItems.length; index++) {
        // Slots does not have parts
        const additionalItem = additionalItems[index];
        if (additionalItem.part) {
            // TODO: Add a test for this case
            parts.add(additionalItem.part.trim().replaceAll(SPACES_REGEX, ","));
        }
    }
};
const addPartForAdditionalModel = (additionalModel, parts) => {
    if (additionalModel != null) {
        addPartForAdditionalItems(additionalModel.start, parts);
        addPartForAdditionalItems(additionalModel.center, parts);
        addPartForAdditionalItems(additionalModel.end, parts);
    }
};
export const computeExportParts = (additionalInfo) => {
    const parts = new Set();
    addPartForAdditionalModel(additionalInfo["block-start"], parts);
    addPartForAdditionalModel(additionalInfo["block-end"], parts);
    addPartForAdditionalModel(additionalInfo["inline-caption"], parts);
    addPartForAdditionalModel(additionalInfo["stretch-start"], parts);
    addPartForAdditionalModel(additionalInfo["stretch-end"], parts);
    return parts;
};
